import React from 'react';

const AccountTypeFormLoading = () => {
  return (
    <div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12 text-center">
          <img src="images/1488.gif" alt="spinner" />
        </div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
      <div className="row">
        <div className="col col-md-12">&nbsp;</div>
      </div>
    </div>
  );
};

export default AccountTypeFormLoading;
